import React, {useState} from 'react'
import {
  MEETING_SPACES_SEQUENCE,
  MEETING_SPACES_SHOW
} from '../../constants/const'
import MeetingRoomHeader from '../../containers/MeetingRoomKiosk/MeetingRoomHeader'
import MeetingRoomInfo from '../../containers/MeetingRoomKiosk/MeetingRoomInfo'
import MeetingRoomSchedule from '../../containers/MeetingRoomKiosk/MeetingRoomSchedule'
import {MeetingRoomFooter} from '../../containers/MeetingRoomKiosk/MeetingRoomFooter'
import styled from 'styled-components'
import {useInterval} from '../../utils/time'
import {
  fetchConferenceRoomReservations,
  meetingRoomCheckInOut
} from '../../api/reservations'
import {fetchRoom} from '../../api/room'
import {useViewFetch} from '../../utils/fetch'
import {useUIDispatch, useUIState} from '../../context/UIContext'
import {useUserState} from '../../context/UserContext'

const getRoomLocation = ({isKiosk, kioskId, defaultLocation}) => {
  let location
  if (isKiosk) {
    const {bl_id: blId, fl_id: flId, rm_id: rmId} = kioskId
    location = {blId, flId, rmId}
  } else {
    location = defaultLocation.location
  }

  return location
}

const ConferenceRoom = () => {
  const [key, setKey] = useState(Math.random())
  const [isCheckingIn, setIsCheckingIn] = useState(false)
  const uiDispatch = useUIDispatch()
  const uiState = useUIState()
  const {kioskId, isKiosk} = uiState

  const {defaultLocation} = useUserState()

  useInterval(() => setKey(Math.random()), 60000)

  const {blId, flId, rmId} = getRoomLocation({
    isKiosk,
    kioskId,
    defaultLocation
  })

  const {data: room} = useViewFetch({
    api: fetchRoom,
    parameters: {blId, flId, rmId}
  })

  const {data: reservations, isLoading} = useViewFetch({
    api: fetchConferenceRoomReservations,
    parameters: {blId, flId, rmId},
    onChangeOf: [key]
  })

  const doCheckInCheckout = async ({reservation}) => {
    setIsCheckingIn(true)
    await meetingRoomCheckInOut(reservation)

    // update reservation list
    setKey(Math.random())
    setIsCheckingIn(false)
  }

  const checkIn = reservation => {
    reservation.verified = 1
    doCheckInCheckout({reservation})
  }

  const checkOut = reservation => {
    reservation.verified = 0
    doCheckInCheckout({reservation})
  }

  const viewMeetingDetails = reservation =>
    uiDispatch({
      type: 'setContent',
      payload: {
        content: MEETING_SPACES_SHOW,
        props: {room: reservation},
        parentPage: 'CONFERENCE_ROOM'
      }
    })

  const viewRoomDetails = () => {
    // TODO: invoke the Room Details screen
  }

  const book = () => {
    const room = {blId, flId, rmId}

    uiDispatch({
      type: 'setContent',
      payload: {
        content: MEETING_SPACES_SEQUENCE,
        props: {room},
        parentPage: 'CONFERENCE_ROOM'
      }
    })
  }

  const createRequest = () =>
    uiDispatch({
      type: 'setContent',
      payload: {content: 'SERVICE_CATALOG', parentPage: 'CONFERENCE_ROOM'}
    })

  return (
    <Container>
      <Header>
        <MeetingRoomHeader onCreateRequest={createRequest} />
      </Header>
      <Info>
        <MeetingRoomInfo reservations={reservations} room={room} />
      </Info>
      <Schedule>
        <MeetingRoomSchedule
          key={key}
          reservations={reservations}
          room={room}
          onCheckIn={checkIn}
          onCheckOut={checkOut}
          onViewMeetingDetails={viewMeetingDetails}
          isLoading={isLoading}
          isCheckingIn={isCheckingIn}
        />
      </Schedule>
      <Footer>
        <MeetingRoomFooter onViewRoomDetails={viewRoomDetails} onBook={book} />
      </Footer>
    </Container>
  )
}

export default ConferenceRoom

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #3c4259;
  display: grid;
  box-sizing: border-box;
  grid-template-rows: 140px 180px calc(100vh - 430px) 110px;
  grid-template-columns: 1fr;
  grid-template-areas: 'header' 'info' 'schedule' 'footer';
  
  @media (max-width: 420px) {
    grid-template-rows: 85px 100px calc(100vh - 295px) 110px;
  }
`

const Header = styled.div`
  grid-area: header;
  height: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #5f6886;
`

const Info = styled.div`
  height: 100%;
  grid-area: info;
`

const Schedule = styled.div`
  grid-area: schedule;
  height: 100%;
  box-sizing: border-box;
`

const Footer = styled.div`
  height: 100%;
  grid-area: footer;
  box-sizing: border-box;
`
